const documents = {
  GENERAL_POLICY: "Regulamin strony",
  COOKIES_POLICY: "Polityka prywatności i cookies",
};

export default documents;
